<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-20 md-small-size-50">
      <md-field>
        <!-- :input="datepicker_inputchanged" -->
        <datepicker
          format="dd/MM/yyyy"
          :typeable="true"
          inputClass="md-input"
          name="filtro_data_inicio"
          v-model="data_cliente.data_ini"
          :language="language_date"
          calendar-button-icon-content="event"
          :input="datepicker_inputchanged"
          placeholder="Data Início"
        ></datepicker>
      </md-field>
    </div>

    <div class="md-layout-item md-size-20 md-small-size-50">
      <md-field>
        <!-- :input="datepicker_inputchanged" -->
        <datepicker
          format="dd/MM/yyyy"
          :typeable="true"
          inputClass="md-input"
          name="filtro_data_fim"
          v-model="data_cliente.data_end"
          :language="language_date"
          calendar-button-icon-content="event"
          :input="datepicker_inputchanged"
          placeholder="Data Fim"
        ></datepicker>
      </md-field>
    </div>

    <div class="md-layout-item md-size-15" v-if="mostra_id">
      <md-field>
        <md-input name="id_filtro" type="text" placeholder="ID" v-model="data_cliente.id_filtro"></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-60 md-small-size-100">
      <md-field>
        <md-input
          name="filtro"
          type="text"
          v-bind:placeholder="titulo_filtro"
          v-model="data_cliente.filtro"
        ></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-medium-size-100">
      <md-field>
        <vue_select
          class="vue-select2"
          name="select2"
          :options="items_clientes"
          v-model="data_cliente.id_cliente"
          v-bind:onChange="change_value"
          :searchable="true"
          language="pt-BR"
          :placeholder="placeholder_cliente"
        ></vue_select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-30 md-medium-size-60">
      <md-field>
        <md-input
          name="filtro_cidade"
          type="text"
          placeholder="Cidade da Unidade"
          v-model="data_cliente.estabelecimento"
        ></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-20 md-medium-size-40">
      <md-field>
        <md-input
          name="filtro_estado"
          type="text"
          placeholder="Estado"
          v-model="data_cliente.estado"
          style="width: 110px"
        ></md-input>
      </md-field>
    </div>
  </div>
</template>
<script>
import vue_select from "../../components/Rend/vue-select/src/Select.vue";

import serviceCliente from "../../services/ClienteService";

import Util from "../../library/Util";

import Datepicker from "../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";

export default {
  components: {
    vue_select: vue_select,
    datepicker: Datepicker
  },
  props: {
    titulo_filtro: {
      type: String,
      default() {
        return "Referência, checklist, estabelecimento ou responsável";
      }
    },
    data_cliente: {
      default() {
        return {
          id_cliente: null,
          estabelecimento: "",
          estado: "",
          id_filtro: "",
          filtro: "",
          data_inicio: null,
          data_fim: null,

          data_ini: null,
          data_end: null
        };
      },
      type: Object
    }
  },
  model: {
    prop: "data_cliente",
    event: "input"
  },
  watch: {
    data_cliente: {
      deep: true,
      handler: function(val) {
        console.log("qual é nossa data início?", this.data_cliente.data_inicio);

        this.data_cliente.data_inicio = Util.dateToBd(
          this.data_cliente.data_ini
        );

        this.data_cliente.data_fim = Util.dateToBd(this.data_cliente.data_end);

        this.$emit("input", this.data_cliente);
      }
    }
  },
  data() {
    return {
      items_clientes: [],

      language_date: ptBR,
      placeholder_cliente: "Carregando clientes..",

      mostra_id: false
    };
  },
  mounted() {
    let self = this;

    console.log(this.$route.query);
    if (
      this.$route.query != null &&
      this.$route.query.com_id != null &&
      this.$route.query.com_id.toString() == "1"
    ) {
      this.mostra_id = true;
    }

    //self.placeholder_cliente  = "..Carregando clientes";
    serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );
      self.placeholder_cliente = "Cliente (digite para pesquisar) ";
    });
  },
  methods: {
    change_value() {
      this.$emit("input", this.data_cliente);
    },
    datepicker_inputchanged(event) {
      console.log("qual é nossa data início?", this.data_cliente.data_inicio);

      this.data_cliente.data_inicio = Util.dateToBd(this.data_cliente.data_ini);

      this.data_cliente.data_fim = Util.dateToBd(this.data_cliente.data_end);
    }
  }
};
</script>